import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Line } from '../Line/Line';

export interface IProps {
  data?: Array<{
    value?: string | number;
    title?: string;
    lineStyle?: {
      lineContainerClass?: string;
      lineTitleClass?: string;
      lineValueClass?: string;
    };
    currency?: boolean;
  }>;
  containerClass?: string;
}

export const InfoLineMessageBox: FC<IProps> = (props: IProps) => {
  const { data, containerClass } = props;
  const { t } = useTranslation();
  return (
    <div className={`w-full p-4 space-y-4  ${containerClass}`}>
      {data?.map((item) => (
        <Line
          key={`${item.title} ${Math.random()}`}
          title={t(item.title || '')}
          value={item.value}
          containerClass={item.lineStyle?.lineContainerClass}
          lineTitleClass={item.lineStyle?.lineTitleClass}
          lineValueClass={item.lineStyle?.lineValueClass}
          currency={item.currency}
        />
      ))}
    </div>
  );
};

InfoLineMessageBox.defaultProps = {
  data: [
    {
      value: '',
      title: '',
      lineStyle: {
        lineContainerClass: '',
      },
      currency: false,
    },
  ],
  containerClass: '',
};

export default InfoLineMessageBox;
